module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/glyphicons-halflings-regular.ttf
// module id = XXWB
// module chunks = 0